var map = {
	"./mb-bank.svg": 66608,
	"./mb-charge.svg": 96921,
	"./mb-pay.svg": 78600,
	"./mb-seven.svg": 99407,
	"./sv-borrow.svg": 35987,
	"./sv-entry.svg": 36062,
	"./sv-recipe.svg": 12812,
	"./sv-return.svg": 80666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45358;